import { ReactNode } from 'react';

import { SessionManager } from '@/components/auth/SessionManager';
import { AdminLayout } from './AdminLayout';

interface AdminRouteShellProps {
  children: ReactNode;
}

export function AdminRouteShell({ children }: AdminRouteShellProps) {
  return (
    <SessionManager timeoutMinutes={15} warningMinutes={2}>
      <AdminLayout>{children}</AdminLayout>
    </SessionManager>
  );
}
